import { Route, Routes } from 'react-router-dom';
import { BoothPage } from './pages/BoothPage';
import { BuilderPage } from './pages/BuilderPage';
import { CustomBoothPage } from './pages/CustomBoothPage';
import { SharePage } from './pages/SharePage';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<BoothPage />} />
      <Route path="/builder" element={<BuilderPage />} />
      {/* Default-booth share pages (rendered by Lambda for crawlers,
          rendered as SPA preview here for humans). */}
      <Route path="/share/p/:id" element={<SharePage kind="photo" />} />
      <Route path="/share/v/:id" element={<SharePage kind="video" />} />
      {/* Custom-booth share pages: /share/p/:slug/:id and /share/v/:slug/:id */}
      <Route path="/share/p/:slug/:id" element={<SharePage kind="photo" />} />
      <Route path="/share/v/:slug/:id" element={<SharePage kind="video" />} />
      {/* Custom booth runtime — anything else single-segment is treated as a slug. */}
      <Route path="/:slug" element={<CustomBoothPage />} />
      <Route path="*" element={<BoothPage />} />
    </Routes>
  );
}
